import { withActions } from '../index';
export var decorators = [withActions];